import React from 'react';
import GearProductPage from '../gear/GearProductPage';

/** All existing PDP routes use the same catalog, offer eligibility and layout. */
export default function SimpleProductPage({ productSlug, specificProductId }) {
  return <GearProductPage productSlug={productSlug} productLookup={specificProductId}/>;
}
